import gql from 'graphql-tag';

export default ({ country, field, parentCode }) => {
  const parent = parentCode ? `, parentCode: "${parentCode}"` : '';
  const getAddressRegions = `getAddressRegions(country: "${country}", field: "${field}"${parent})`;
  return gql`
    query {
      ${getAddressRegions} {
        code
        name
        parentCode
      }
    }
  `;
};
